export default __webpack_public_path__ + "static/media/wa-1715-2.95233a5a.jpg";